import { ShieldAlert } from "lucide-react";
import { useMarketingSettings } from "@/hooks/sms/useMarketingSettings";

/**
 * Persistent banner shown on every /marketing page while the emergency stop
 * is on, so nobody wonders why campaigns are not sending. Renders nothing
 * once the kill switch is off (or before settings load). Pages that render
 * it are added by later PRs (the /marketing shell does not exist yet).
 */
const KillSwitchBanner = () => {
  const { data: settings } = useMarketingSettings();
  if (!settings?.kill_switch) return null;

  return (
    <div className="flex items-center gap-3 rounded-lg border border-status-danger/40 bg-status-danger/10 px-4 py-3 text-status-danger">
      <ShieldAlert className="h-5 w-5 shrink-0" />
      <p className="text-sm font-medium">
        All marketing texts are stopped. Turn this off in Settings &rarr; Text marketing &rarr; Emergency stop.
      </p>
    </div>
  );
};

export default KillSwitchBanner;
